<template>
  <div :class="classes.headerWrapper">
    <OperatorLogo :class="classes.logo" />
    <a
      :href="links.provider"
      target="_blank"
      :class="classes.headerButton"
      @click="handleClick"
      >{{ ctaText }}</a
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { useBrand } from "../hooks/useBrand";
import { useBetData } from "../hooks/useBetData";
import * as language from "../lib/language";

import OperatorLogo from "./OperatorLogo.vue";
import { AnalyticEvents } from "../types/analytics";
import { useHandleAnalytics } from "../lib/analytics";
import Boulder from "../images/Boulder.svg";

const useStyles = createUseStyles({
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    padding: "10px 0",
    boxSizing: "border-box"
  },
  logo: {
    maxWidth: "80px",
    maxHeight: "29px",
    justifyContent: "center",
    display: "flex"
  },
  headerButton: {
    fontSize: "10px",
    lineHeight: "12px",
    color: "#0066CC",
    textTransform: "uppercase",
    padding: "5px 17px",
    border: "1px solid #4C99E6",
    borderRadius: "15px",
    fontWeight: 600,
    "&:after": {
      width: "8px",
      height: "8px",
      content: "''",
      display: " inline-block",
      marginLeft: "3px",
      backgroundImage: `url(${Boulder})`,
      backgroundRepeat: "no-repeat"
    },
    "&:hover": {
      backgroundColor: "#CCE0F5",
      cursor: "pointer",
      border: "1px solid #CCE0F5"
    },
    "&:focus": {
      borderColor: "#CCE0F5"
    },
    "&:active": {
      borderColor: "#CCE0F5"
    }
  }
});

export default defineComponent({
  name: "Header",
  components: {
    OperatorLogo
  },
  setup() {
    const { headerBranding, operator } = useBrand();
    const classesRef = useStyles();
    const { links } = useBetData();
    const $handleAnalytics = useHandleAnalytics();

    const languageCode = language.getLanugeCodeFromUrl();
    const ctaText = language.getValue(operator.value.key, languageCode, "cta");

    const handleClick = () => {
      const statsEvent = AnalyticEvents.CLICKED_THROUGH;
      const statsDesc = "Bet now link";
      $handleAnalytics(statsEvent, statsDesc);
    };

    return {
      links,
      headerBranding,
      classes: classesRef.value,
      ctaText,
      handleClick
    };
  }
});
</script>

<style></style>
